// extracted by mini-css-extract-plugin
export default {"buttons":"CreateNotification_buttons__sE+zk","container":"CreateNotification_container__oV02L"};